<div  class="catalogue-main">
  <div class="conatiner-page-header">{{ selectedPrimaryTab }}</div>
  <mat-tab-group class="catalog-main-tabs" [selectedIndex]="selectedPrimaryTabIndex" (selectedTabChange)="onPrimaryTabChange($event)"
    animationDuration="0ms">
    <ng-template ngFor let-primaryTab [ngForOf]="primaryTabs">
      <ng-template [ngIf]="!primaryTab.disabled">
        <mat-tab *accessCheck="primaryTab?.name" [label]="primaryTab?.name"> 
        <!---Products-->
        <ng-template [ngIf]="primaryTab?.name===features?.products">
          <ng-container *ngTemplateOutlet="productTabContentRef"></ng-container>
        </ng-template>
        <!---Investors-->
        <ng-template [ngIf]="primaryTab?.name===features?.investors">
          <ng-container *ngTemplateOutlet="investorTabContentRef"></ng-container>
        </ng-template>
        <!---Partners-->   
        <ng-template [ngIf]="primaryTab?.name===features.partners">
            <ng-container *ngTemplateOutlet="partnersTabContentRef"></ng-container>
        </ng-template>
        <!---Downloads-->   
        <ng-template [ngIf]="primaryTab?.name===features.downloads">
            <ng-container *ngTemplateOutlet="downloadsTabContentRef"></ng-container>
        </ng-template>
        <!---NFO--> 
        <ng-template [ngIf]="primaryTab?.name===features.nfo">
            <ng-container *ngTemplateOutlet="nfoTabContentRef"></ng-container>
        </ng-template>
        <!--CEO Desk-->
        <ng-template [ngIf]="primaryTab?.name===features.ceoDesk">
            <ng-container *ngTemplateOutlet="ceoDeskTabContentRef"></ng-container>
        </ng-template>
        <!--Latest News-->
          <ng-template [ngIf]="primaryTab?.name===features.latestNews">
            <ng-container *ngTemplateOutlet="latestNewsTabContentRef"></ng-container>
        </ng-template>
        <!--Media-->
        <ng-template [ngIf]="primaryTab?.name===features.media">
          <ng-container *ngTemplateOutlet="mediaTabContentRef"></ng-container>
        </ng-template>
        <!--Careers-->
        <ng-template [ngIf]="primaryTab?.name===features.careers">
          <ng-container *ngTemplateOutlet="careersTabContentRef"></ng-container>
        </ng-template>
        <!--Contact Us-->
          <ng-template [ngIf]="primaryTab?.name===features.contactUs">
            <ng-container *ngTemplateOutlet="contactUsTabContentRef"></ng-container>
          </ng-template>
        <!--User Data-->
          <ng-template [ngIf]="primaryTab?.name===features.userData">
            <ng-container *ngTemplateOutlet="userDataTabContentRef"></ng-container>
          </ng-template>
        <!--Relationship Manager-->    
          <ng-template [ngIf]="primaryTab?.name===features.relationshipManager">
            <ng-container *ngTemplateOutlet="relationshipManagerTabContentRef"></ng-container>
          </ng-template>
        <!--Nav Dividends-->   
          <ng-template [ngIf]="primaryTab?.name===features.navDividends">
            <ng-container *ngTemplateOutlet="navDividendsTabContentRef"></ng-container>
        </ng-template>
        <!--Advertisement--> 
        <ng-template [ngIf]="primaryTab?.name===features.advertisement">
            <ng-container *ngTemplateOutlet="advertisementTabContentRef"></ng-container>
          </ng-template>
        <!--Expense Ratio--> 
          <ng-template [ngIf]="primaryTab?.name===features.expenseRatio">
            <ng-container *ngTemplateOutlet="expenseRatioTabContentRef"></ng-container>
          </ng-template>
        <!--Digital Factsheet--> 
          <ng-template [ngIf]="primaryTab?.name===features.digitalFactsheet">
            <ng-container *ngTemplateOutlet="digitalFactsheetTabContentRef"></ng-container>
          </ng-template>
          <!--About US-->
          <ng-template [ngIf]="primaryTab?.name===features.aboutUs">
            <ng-container *ngTemplateOutlet="aboutUsTabContentRef"></ng-container>
          </ng-template>
          <!-- IAP Page -->
          <ng-template [ngIf]="primaryTab?.name===features.IAPpage">
            <ng-container *ngTemplateOutlet="iapPageTabContentRef"></ng-container>
          </ng-template>
      </mat-tab>
    </ng-template>
  </ng-template>
  </mat-tab-group>
</div>


<!---Products Tab Content Ref--->
<ng-template #productTabContentRef> 
  <ng-template [ngIf]="selectedPrimaryTab===features?.products">
      <mat-tab-group class="catalog-tabs" [selectedIndex]="selectedSecondaryTabIndex" (selectedTabChange)="onSecondaryTabChange($event)"
      animationDuration="0ms">
        <mat-tab label="Images">
          <app-catalogue-images *ngIf="selectedSecondaryTab === 'Images'"   [sectionList]="imageSectionList"></app-catalogue-images>
        </mat-tab>
        <mat-tab label="Excel">
          <app-catalogue-excel *ngIf="selectedSecondaryTab === 'Excel'" [categoryList]="categoryList"></app-catalogue-excel>
        </mat-tab>
        <mat-tab label="Videos">
          <app-catalogue-videos [selectedTab]="'Products'" *ngIf="selectedSecondaryTab === 'Videos'"></app-catalogue-videos>
        </mat-tab>
        <mat-tab label="PDF">
          <app-forms *ngIf="selectedSecondaryTab === 'PDF'" [pdfTypes]="pdfTypes" [selectedTab]="'PDF'"></app-forms>
        </mat-tab>
    </mat-tab-group>
  </ng-template>
</ng-template>

<!---Investor Tab Content Ref--->
<ng-template #investorTabContentRef>
  <ng-template [ngIf]="selectedPrimaryTab===features?.investors">
    <mat-tab-group class="catalog-tabs" [selectedIndex]="selectedSecondaryTabIndex" (selectedTabChange)="onSecondaryTabChange($event)" animationDuration="0ms">
      <mat-tab label="Upload">
        <app-forms *ngIf="selectedSecondaryTab === 'Upload'" [pdfTypes]="pdfTypes"></app-forms>
      </mat-tab>
    <mat-tab label="Videos">
      <app-catalogue-videos *ngIf="selectedSecondaryTab === 'Videos'" [selectedTab]="'Investors'"></app-catalogue-videos>
    </mat-tab>
    <mat-tab label="Sections">
      <app-sections [hideSubsection]="true" *ngIf="selectedSecondaryTab === 'Sections'" [selectedTab]="'Investors'" [typeList]="pdfTypes"></app-sections>
    </mat-tab>
  </mat-tab-group>
  </ng-template>
</ng-template>

<!---Partners Tab Content Ref--->
<ng-template #partnersTabContentRef>
  <ng-template [ngIf]="selectedPrimaryTab===features.partners">
    <mat-tab-group class="catalog-tabs" [selectedIndex]="selectedSecondaryTabIndex" (selectedTabChange)="onSecondaryTabChange($event)"
    animationDuration="0ms">
    <mat-tab label="Upload">
      <app-forms *ngIf="selectedSecondaryTab === 'Upload'" [pdfTypes]="pdfTypes"></app-forms>
    </mat-tab>
    <mat-tab label="Sections">
      <app-sections *ngIf="selectedSecondaryTab === 'Sections'" [selectedTab]="'Partners'" [typeList]="pdfTypes"></app-sections>
    </mat-tab>
  </mat-tab-group>
</ng-template>
</ng-template>

<!---Downloads Tab Content Ref--->
<ng-template #downloadsTabContentRef>
  <ng-template [ngIf]="selectedPrimaryTab===features.downloads">
    <mat-tab-group class="catalog-tabs" [selectedIndex]="selectedSecondaryTabIndex" (selectedTabChange)="onSecondaryTabChange($event)"
      animationDuration="0ms">
      <mat-tab label="Upload">
        <app-forms *ngIf="selectedSecondaryTab === 'Upload'" [pdfTypes]="pdfTypes"></app-forms>
      </mat-tab>
      <mat-tab label="Sections">
        <app-sections *ngIf="selectedSecondaryTab === 'Sections'" [selectedTab]="'Downloads'" [typeList]="pdfTypes"></app-sections>
      </mat-tab>
    </mat-tab-group>
  </ng-template>
</ng-template>

<!---NFO Tab Content Ref--->
<ng-template #nfoTabContentRef>
  <ng-template [ngIf]="selectedPrimaryTab===features.nfo">
    <mat-tab-group class="catalog-tabs" [selectedIndex]="selectedSecondaryTabIndex" (selectedTabChange)="onSecondaryTabChange($event)"
      animationDuration="0ms">
      <mat-tab label="Images">
        <app-catalogue-images *ngIf="selectedSecondaryTab === 'Images'" [sectionList]="imageSectionList"></app-catalogue-images>
      </mat-tab>
      <mat-tab label="Excel">
        <app-catalogue-excel *ngIf="selectedSecondaryTab === 'Excel'" [categoryList]="categoryList"></app-catalogue-excel>
      </mat-tab>
    </mat-tab-group>
  </ng-template>
</ng-template>

<!---CEO Desk Tab Content Ref--->
<ng-template #ceoDeskTabContentRef >
  <ng-template [ngIf]="selectedPrimaryTab===features.ceoDesk">
    <mat-tab-group class="catalog-tabs" [selectedIndex]="selectedSecondaryTabIndex" (selectedTabChange)="onSecondaryTabChange($event)"
      animationDuration="0ms">
      <mat-tab label="Upload">
        <app-catalogue-articles *ngIf="selectedSecondaryTab === 'Upload'" [primaryTab]="selectedPrimaryTab" [secondaryTab]="selectedSecondaryTab" (uploadThumbnailChange)="onUploadThumbnail($event)"  [typeList]="categoryList"></app-catalogue-articles>
      </mat-tab>
      <mat-tab label="Images">
        <app-catalogue-images *ngIf="selectedSecondaryTab === 'Images'" [sectionList]="imageSectionList"></app-catalogue-images>
      </mat-tab>
      <mat-tab label="Thumbnail Images">
        <app-catalog-thumbnail *ngIf="selectedSecondaryTab === 'Thumbnail Images'" [data]="articleData" [typeList]="categoryList"></app-catalog-thumbnail>
      </mat-tab>
    </mat-tab-group>
  </ng-template>
</ng-template>

<!---Latest News Tab Content Ref--->
<ng-template #latestNewsTabContentRef>
  <ng-template [ngIf]="selectedPrimaryTab===features.latestNews">
    <mat-tab-group class="catalog-tabs" [selectedIndex]="selectedSecondaryTabIndex" (selectedTabChange)="onSecondaryTabChange($event)"
      animationDuration="0ms">
      <mat-tab label="Upload">
        <app-catalogue-articles *ngIf="selectedSecondaryTab === 'Upload'" [typeList]="categoryList"></app-catalogue-articles>
      </mat-tab>
    </mat-tab-group>
  </ng-template>
</ng-template>

<!---Media Tab Content Ref--->
<ng-template #mediaTabContentRef>
  <ng-template [ngIf]="selectedPrimaryTab===features.media">
      <mat-tab-group class="catalog-tabs" [selectedIndex]="selectedSecondaryTabIndex" (selectedTabChange)="onSecondaryTabChange($event)"
        animationDuration="0ms">
        <mat-tab label="Upload">
          <app-catalogue-articles *ngIf="selectedSecondaryTab === 'Upload'" [typeList]="categoryList"></app-catalogue-articles>
        </mat-tab>
      </mat-tab-group>
  </ng-template>
</ng-template>

<!---Careers Tab Content Ref--->
<ng-template #careersTabContentRef>
  <ng-template [ngIf]="selectedPrimaryTab===features.careers">
    <mat-tab-group class="catalog-tabs" [selectedIndex]="selectedSecondaryTabIndex" (selectedTabChange)="onSecondaryTabChange($event)"
      animationDuration="0ms">
      <mat-tab label="Careers">
        <app-catalouge-careers *ngIf="selectedSecondaryTab === 'Careers'"></app-catalouge-careers>
      </mat-tab>
      <mat-tab label="Config">
        <app-catalogue-career-config *ngIf="selectedSecondaryTab === 'Config'"></app-catalogue-career-config>
      </mat-tab>
      <mat-tab label="Images">
        <app-catalogue-images *ngIf="selectedSecondaryTab === 'Images'" [sectionList]="imageSectionList"></app-catalogue-images>
      </mat-tab>
    </mat-tab-group>
</ng-template>
</ng-template>

<!---ContactUs Content Ref--->
<ng-template #contactUsTabContentRef>
  <ng-template [ngIf]="selectedPrimaryTab===features.contactUs">
    <mat-tab-group class="catalog-tabs" [selectedIndex]="selectedSecondaryTabIndex" (selectedTabChange)="onSecondaryTabChange($event)"
      animationDuration="0ms">
      <mat-tab label="Excel">
        <app-catalogue-excel *ngIf="selectedSecondaryTab === 'Excel'" [categoryList]="categoryList"></app-catalogue-excel>
      </mat-tab>
    </mat-tab-group>
  </ng-template>
</ng-template>

<!---User Data Content Ref--->
<ng-template #userDataTabContentRef>
  <ng-template [ngIf]="selectedPrimaryTab===features.userData">
    <app-user-data></app-user-data>
  </ng-template>
</ng-template>

<!---Relationship Manager Content Ref--->
<ng-template #relationshipManagerTabContentRef>
  <ng-template [ngIf]="selectedPrimaryTab===features.relationshipManager">
    <mat-tab-group class="catalog-tabs" [selectedIndex]="selectedSecondaryTabIndex" (selectedTabChange)="onSecondaryTabChange($event)"
      animationDuration="0ms">
      <mat-tab label="Excel">
        <app-catalogue-excel *ngIf="selectedSecondaryTab === 'Excel'" [categoryList]="categoryList"></app-catalogue-excel>
      </mat-tab>
    </mat-tab-group>
  </ng-template>
</ng-template>

<!---Nav Dividends Content Ref--->
<ng-template #navDividendsTabContentRef>
  <ng-template [ngIf]="selectedPrimaryTab===features.navDividends">
    <mat-tab-group class="catalog-tabs" [selectedIndex]="selectedSecondaryTabIndex" (selectedTabChange)="onSecondaryTabChange($event)"
      animationDuration="0ms">
      <mat-tab label="Nav & Dividends">
        <app-catalogue-nav-dividends *ngIf="selectedSecondaryTab === 'NavDividends'"></app-catalogue-nav-dividends>
      </mat-tab>
    </mat-tab-group>
  </ng-template>
</ng-template>

<!---Advertisement Content Ref--->
<ng-template #advertisementTabContentRef>
  <ng-template [ngIf]="selectedPrimaryTab===features.advertisement">
    <mat-tab-group class="catalog-tabs" [selectedIndex]="selectedSecondaryTabIndex" (selectedTabChange)="onSecondaryTabChange($event)"
      animationDuration="0ms">
      <mat-tab label="Upload">
        <app-catalogue-articles *ngIf="selectedSecondaryTab === 'Upload'" [typeList]="categoryList"></app-catalogue-articles>
      </mat-tab>
    </mat-tab-group>
  </ng-template>
</ng-template>

<!---Expense Ratio Content Ref--->
  <ng-template #expenseRatioTabContentRef>
    <ng-template [ngIf]="selectedPrimaryTab===features.expenseRatio">
      <mat-tab-group class="catalog-tabs" [selectedIndex]="selectedSecondaryTabIndex" (selectedTabChange)="onSecondaryTabChange($event)"
        animationDuration="0ms">
        <mat-tab label="Upload">
          <app-forms *ngIf="selectedSecondaryTab === 'Upload'" [pdfTypes]="pdfTypes" [selectedMainTab]="'Expense Ratio'"></app-forms>
        </mat-tab>
      </mat-tab-group>
    </ng-template>
</ng-template>

<!---Digital Factsheet Content Ref --->
<ng-template #digitalFactsheetTabContentRef>
  <ng-template [ngIf]="selectedPrimaryTab===features.digitalFactsheet">
    <mat-tab-group class="catalog-tabs" [selectedIndex]="selectedSecondaryTabIndex" (selectedTabChange)="onSecondaryTabChange($event)"
      animationDuration="0ms">
      <mat-tab label="Digital Factsheet">
        <app-catalogue-digital-factsheet *ngIf="selectedSecondaryTab === 'digitalFactsheet'"></app-catalogue-digital-factsheet>
      </mat-tab>
    </mat-tab-group>
  </ng-template>
</ng-template>

<!--about Us Content Ref-->
<ng-template #aboutUsTabContentRef>
  <ng-template [ngIf]="selectedPrimaryTab===features.aboutUs">
    <mat-tab-group class="catalog-tabs" [selectedIndex]="selectedSecondaryTabIndex" (selectedTabChange)="onSecondaryTabChange($event)"
      animationDuration="0ms">
      <mat-tab label="Upload">
        <app-catalouge-our-team *ngIf="selectedSecondaryTab === 'Upload'"></app-catalouge-our-team>
      </mat-tab>
    </mat-tab-group>
</ng-template>
</ng-template>

<!-- IAP Page Content  Ref -->
<ng-template #iapPageTabContentRef>
  <ng-template [ngIf]="selectedPrimaryTab===features.IAPpage">
    <mat-tab-group class="catalog-tabs" [selectedIndex]="selectedSecondaryTabIndex" (selectedTabChange)="onSecondaryTabChange($event)"
      animationDuration="0ms">
      <mat-tab label="Upload">
        <app-catalogue-iap-page *ngIf="selectedSecondaryTab === 'Upload'"></app-catalogue-iap-page>
      </mat-tab>
    </mat-tab-group>
</ng-template>
</ng-template>